/**
 * 65.32 (DECISIONS 189): the default squad types (data; the Lab's layouts count them) and the layout presets it suggests.
 * Three to a squad, as `squadSize`'s default.
 */
import type { SquadType, SideLayout } from '../types/loadout';

export const SQUAD_TYPES: Record<string, SquadType> = {
  line: { key: 'line', name: 'Line', members: [{ primary: 'rifle' }, { primary: 'rifle' }, { primary: 'rifle' }] },
  support: { key: 'support', name: 'Support', members: [{ primary: 'rifle' }, { primary: 'rifle' }, { primary: 'lmg' }] },
  antiArmour: { key: 'antiArmour', name: 'Anti-armour', members: [{ primary: 'rifle' }, { primary: 'rifle' }, { primary: 'rifle', secondary: 'rocket' }] },
  close: { key: 'close', name: 'Close', members: [{ primary: 'smg' }, { primary: 'smg' }, { primary: 'smg' }] },
  // 65.31 step 4: the 40 mm in a squad — only where a layout counts it (no default layout does but the Lab's suggestion)
  grenadier: { key: 'grenadier', name: 'Grenadier', members: [{ primary: 'rifle' }, { primary: 'rifle' }, { primary: 'rifle', secondary: 'gl40' }] },
};

/** The layouts the Lab suggests (each a side of 12, as its default people per side). */
export const LAYOUT_PRESETS: Record<string, SideLayout> = {
  standard: [{ type: 'line', count: 2 }, { type: 'support', count: 1 }, { type: 'antiArmour', count: 1 }],
  supportHeavy: [{ type: 'line', count: 1 }, { type: 'support', count: 3 }],
  antiArmour: [{ type: 'line', count: 2 }, { type: 'antiArmour', count: 2 }],
  close: [{ type: 'close', count: 2 }, { type: 'support', count: 1 }, { type: 'line', count: 1 }],
  grenadiers: [{ type: 'line', count: 1 }, { type: 'support', count: 1 }, { type: 'grenadier', count: 2 }],
};

/** The Lab's cap on a side (people), as its People per side row's. */
export const LAYOUT_MAX_PEOPLE = 50;
